import { render } from "./ContentContainer.vue?vue&type=template&id=00622a8e&scoped=true"
const script = {}

import "./ContentContainer.vue?vue&type=style&index=0&id=00622a8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00622a8e"]])

export default __exports__